export const CREATED = 'created'
export const READY = 'ready'
export const GENERATING = 'generating'
export const FAILED = 'failed'
